<script>
  import { getContext } from "svelte";
  import { Modal as DangerModal } from "carbon-components-svelte";
  import { ROUTES } from "@utils/routes.js";
  import { Button } from "paxray-components-svelte";
  import { projectListStore } from "@stores/damProjectsStore.js";
  import { ARROW_LEFT_ICON } from "@utils/icons.js";

  export let idproject;
  export let step;
  export let stage;
  export let toastMsg;
  export let saveSuccessful;
  export let showGoBackButton = true;
  export let showMarkAsCompletedButton = true;
  export let disabled = false;
  export let allowAdminOverride = true;
  export let confirmBeforeComplete = true;
  export let showCompletedState = true;
  export let iconLeft = false;
  export let icon = null;
  export let text = "Mark as Completed";
  export let size = "md";
  export let completionWarning =
    "After completion, this step cannot be changed. This action cannot be undone.";
  export let onClick = handleMarkAsCompleted;
  let completed = false;
  let confirmationOpen = false;
  const role = getContext("role");

  $: isAdmin = $role?.role === "admin";
  $: effectiveDisabled = disabled && !(allowAdminOverride && isAdmin);

  const { markStepAsCompleted, isStepCompleted } = projectListStore;

  $: checkCompleted(idproject, step, stage);

  async function checkCompleted(idproject, step, stage) {
    if (!showCompletedState) return;
    completed = await isStepCompleted(idproject, step, stage);
  }

  async function handleMarkAsCompleted() {
    const data = await markStepAsCompleted(idproject, step, stage);
    if (data?.ok) {
      toastMsg = `${step} step marked as completed.`;
      saveSuccessful = true;
      completed = true;
      window.location.assign(`${ROUTES.dam.progress}?idproject=${idproject}`);
    } else {
      toastMsg = data?.message || data?.error || "An error occurred.";
      saveSuccessful = false;
    }
  }
  function handleGoBackToProgress() {
    window.location.assign(`${ROUTES.dam.progress}?idproject=${idproject}`);
  }

  function handleCompletionClick() {
    if (confirmBeforeComplete) {
      confirmationOpen = true;
      return;
    }

    onClick();
  }

  function confirmCompletion() {
    confirmationOpen = false;
    onClick();
  }

  export function refresh() {
    checkCompleted(idproject, step, stage);
  }
</script>

{#if showGoBackButton}
  <Button
    kind="secondary"
    text={`Back to Progress`}
    on:click={handleGoBackToProgress}
    iconLeft
    icon={ARROW_LEFT_ICON}
  />
{/if}
{#if completed}
  <div class="completed-badge" class:completed-badge-sm={size === "sm"}>
    <span>Completed</span>
  </div>
{:else if showMarkAsCompletedButton}
  <Button
    kind="secondary"
    {text}
    size="field"
    disabled={effectiveDisabled}
    {iconLeft}
    {icon}
    on:click={handleCompletionClick}
  />
{/if}

{#if confirmBeforeComplete}
  <DangerModal
    danger
    bind:open={confirmationOpen}
    preventCloseOnClickOutside
    modalHeading={text}
    primaryButtonText={text}
    secondaryButtonText="Cancel"
    on:click:button--primary={confirmCompletion}
    on:click:button--secondary={() => (confirmationOpen = false)}
    on:close={() => (confirmationOpen = false)}
  >
    <p>
      {completionWarning}
    </p>
  </DangerModal>
{/if}

<style>
  .completed-badge {
    border-radius: 0.5rem;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
    padding: 0 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 3rem;
    background: #8ef095;
    opacity: 0.5;
    color: #1c1c20;
  }

  .completed-badge-sm {
    height: 2.5rem;
  }
</style>
